// Used a scoped function to add the possibility to avoid to execute the code
import LoginManagementService from '@assets/js/imaios-connection-management/login-management-service';

(function () {
	const licenceCheckBox = document.getElementById('licenceCheckbox');
	const licenceAgree = document.getElementById('saveLicence');
	const licenceAgreeModal = document.getElementById('anatomy-licence-agreement');

	const PRODUCT_FREE_ACCESS = [ 'prd_demo', 'prd_bt' ];

	if (licenceAgreeModal == null) {
		return;
	}

	let formation = '';
	let productId = '';
	if (licenceAgreeModal) {
		if ('formation' in licenceAgreeModal.dataset) {
			formation = licenceAgreeModal.dataset.formation;
		}

		if (formation !== '') {
			productId = formation;
		}
	}

	let path = window.location.pathname;

	if (path.includes('e-anatomy')) {
		productId = 'prd_eanat';
	}

	if (path.includes('vet-anatomy')) {
		productId = 'prd_vet';
	}

	// Let the modal hide by default
	$('#anatomy-licence-agreement').modal({ backdrop: 'static', keyboard: false, show: false });

	// Check if user has agreed to license agreements
	LoginManagementService.awaitConnection()
		.then(async () => {
			const userAccess = await LoginManagementService.getUserAccess();
			if (!LoginManagementService.isConnected()) {
				return;
			}

			fetch(`/api/user/licence-agreements/${productId}`)
				.then(res => {
					// If we have found a license do not show the modal
					if (res.status === 200) {
						return;
					}

					if (productId in userAccess) {
						// Display modal for groups
						if (userAccess[productId].group_premium) {
							$('#anatomy-licence-agreement').modal('show');
						}
						else if (userAccess[productId].individual_premium) {
							// Auto accept license for individual premium and do not show the modal
							void acceptLicenceAgreement(productId);
						}
					}
					else if (PRODUCT_FREE_ACCESS.includes(productId)) {
						void acceptLicenceAgreement(productId);
					}
				});
		});

	document.getElementById('cancelLicence').addEventListener('click', function (event) {
		event.preventDefault();
		let url = window.location.href;
		let domain = (new URL(url));
		let locale = url.split('/')[3];
		domain = domain.hostname;
		window.location.replace(`https://${domain}/${locale}`);
	});

	if (licenceAgree) {
		licenceCheckBox.addEventListener('click', manageLicenceButton);
		document.getElementById('licenceAcceptationText').addEventListener('click', manageLicenceButton);
		licenceAgree.addEventListener('click', function (event) {
			event.preventDefault();
			if (licenceCheckBox.checked) {
				fetch(`/api/user/licence-agreements/${productId}`, {
					method: 'POST'
				})
					.then(res => res.json())
					.then((response) => {
						document.getElementById('anatomy-licence-agreement').classList.add('hide');
						document.getElementById('anatomy-licence-agreement').classList.remove('show');

					});
			}
			else {
				licenceAgree.disabled = true;
			}
		});

		function manageLicenceButton() {
			licenceCheckBox.checked = !licenceCheckbox.checked;
			licenceAgree.disabled = !licenceCheckBox.checked;
		}
	}

	function acceptLicenceAgreement(productId) {
		// Auto accept licence for individual premium and do not show the modal
		return fetch(`/api/user/licence-agreements/${productId}`, {
			method: 'POST',
			headers: {
				'fromModal': true
			}
		});
	}
})();
